import Role from '../role';
import Manager from './manager';
import Operator from './operator';

export default class Administrator extends Role {
  constructor(id) {
    super({ id, name: 'administrator', translations: { fr: 'administrateur' } });
  }

  // eslint-disable-next-line class-methods-use-this
  can() {
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  assignableRoles() {
    return [new Administrator(), new Manager(), new Operator()];
  }
}
